import "./App.css";
import { Route, Routes } from "react-router-dom";
import Senario from "./Scenario/Senario";

function App() {
  return (
    <div className="">
      <Routes>
        <Route path="/" element={<Senario />} />
      </Routes>
    </div>
  );
}

export default App;
